export const ItemForLs = (id = 0, title = "", poster_path = "") => ({
  id: id,
  title: title,
  poster_path: poster_path,
});
